import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';

import "./Widget.js";

/**
    * class HSN.Widget.WriteReview
    *
    * Encapsulates the common functionality of the WriteReview Widget.
    **/
HSN.Widget.WriteReview = function () {
    var application;
    var commerceService;
    var deviceInformation;
    var scope = this;
    /**
        * new HSN.Widget.WriteReview.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.WriteReview]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with
        **/
    HSN.OnAccountStatusDetailLoad(function (data) {
        scope.bazaarVoiceUasToken = data.BazaarVoiceUasToken;
    });
    function init(config) {
        application = config.application;
        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;
    }
    function execute(productIdentity) {
        commerceService.CheckProductReviewable({productIdentity : productIdentity}, {
            callback: function (data) {
                if (data.success) {
                    if (application.GetAppFeatures('writereview', '1')) {
                        var command = 'hsn://HSNWebView.WriteReview/' + productIdentity;
                        gap.ExecCommand(command);
                        return false;
                    }
                    BV.ui('rr', 'submit_review',{productId : productIdentity, userToken : scope.bazaarVoiceUasToken});
                }
                else {
                    if (data.status === 8 || data.status === 9) {
                        HsnDrdPageCache.setCookie('signin', 'ref=' + encodeURIComponent(window.location.pathname), HsnDrdPageCache.getLowerDomain(), null, '/');
                        Navigate('/nickname');
                        return;
                    }
                    if (data.status === 1) {
                        HsnDrdPageCache.setCookie('signin', 'ref=' + encodeURIComponent(window.location.pathname), HsnDrdPageCache.getLowerDomain(), null, '/');
                        Navigate('/signin');
                        return;
                    }
                    var errorContent = '<div><div class="write-review-error-container"><p>' + data.error + '</p><div id="ok-button" class="submit-button main-button blue" tabindex="0">ok</div></div></div>';
                    ShowError(errorContent);
                }
            },
            errorCallback: function () {
                alert('Unfortunately there was an error attempting to write your review, please try again.');
                HSN.RemoveWait();
            }
        });
    }
    function BindModalHandler(modalScope) {
        $('.submit-button', modalScope.Content).on('click keydown', function () {
            modalScope.Hide();
            return false;
        });
    }
    function Navigate(url) {
        if (application.DeviceInformation.IsNativeApp) {
            if (url === '/signin' && application.DeviceInformation.HasNativeSignin) {
                var jsonData = { "returnUrl": window.location.href };
                var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
                gap.ExecCommand(command);
            }
            url = gap.FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command = gap.BuildGapCommand(url);
            gap.ExecCommand(command);
        }
        else {
            window.location.href = url;
        }
    }
    function ShowError(content) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(content, true);
        BindModalHandler(modalReference);        
        $('.write-review-container .submit-button', modalReference.Content).focus();

        return false;
    }
    return {
        init: init,
        execute: execute
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/WriteReview.js